<script>
import api from './../apiBridge'
import formatting from './../common/formatting.js'
import router from './../router';
import OrderHeader from './OrderHeader.vue';
import OrderItems from './OrderItems.vue';
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {checkFilterCriteria} from './../common/utils.js'



export default {

  name: 'recall',

  components: {
    'orderheader': OrderHeader,
    'orderitems': OrderItems,
    'swiper': swiper,
    'slide': swiperSlide
  },


  created: function () {
    // private data
  },

  methods: {
    getRecallList() {
      console.log('Get recall list');
      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getRecallList';
      apiParameters.queryString['store_number'] = api.storeNumber;

      api.httpGet(apiParameters, function (response) {
        if (response.nativeError == 'connection_error') {
          self.error = self.$t('connection_error');
          return;
        }

        let orderListRaw = response.data;
        self.orderList = [];

        if (orderListRaw && orderListRaw.length) {
          // set current time based on returned system time
          self.currentTime = (orderListRaw[0].checkdetails.Curr_DT)
                          ? formatting.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT)
                          : null;


          // filter out any orders we shouldn't process
          orderListRaw = orderListRaw.filter(self.filterOutOrder);


          let alreadyThere = false;
          for (let r=0; r < orderListRaw.length; r++) {
            alreadyThere = false;
            for (let o=0; o < self.orderList.length; o++) {
              if (orderListRaw[r].checkdetails.chk_num == self.orderList[o].checkdetails.chk_num) {
                alreadyThere = true;

                // update based on latest date and sequence num
                if (orderListRaw[r].checkdetails.last_update_tm > self.orderList[o].checkdetails.last_update_tm
                    || orderListRaw[r].checkdetails.trans_seq > self.orderList[o].checkdetails.trans_seq) {
                  self.orderList[o] = orderListRaw[r];
                }

              }
            }

            if (!alreadyThere) {
              self.orderList.push(orderListRaw[r]);
            }
          }
        }

        if (!self.orderList || !self.orderList.length) {
          // use default static data for testing
//          self.orderList = data.sampleData1();
        }

        // sort by datetime oldest to newest
        self.orderList.sort(function(a,b) {
                            const dta = formatting.dateFormat.dateFromStr(a.checkdetails.bumpTime);
                            const dtb = formatting.dateFormat.dateFromStr(b.checkdetails.bumpTime);

                            if (dta > dtb)
                                return -1;
                            if (dta < dtb)
                                return 1;
                            return 0;
                        });


        if (self.orderList && self.orderList.length) {

          // limit to 40
          self.orderList = self.orderList.slice(0, 40);

          for (let o=0; o < self.orderList.length; o++) {
            self.panelAnimation.push(true);
            self.panelShrink.push(false);
            self.panelFade.push(false);


            let orderTime = formatting.dateFormat.dateFromStr(self.orderList[o].checkdetails.bumpTime)
            self.orderList[o].checkdetails.displayTime = formatting.dateFormat.timeHMampm(orderTime);

            let timeDiff = formatting.dateFormat.calcDiffInMinutes(self.currentTime, orderTime);
            if (timeDiff >= 120) {
              self.orderList[o].checkdetails.timeColour = '#FF0000'
            } else if (timeDiff >= 60) {
              self.orderList[o].checkdetails.timeColour = '#FF8C00'
            } else {
              self.orderList[o].checkdetails.timeColour = '#008000'
            }
          }

        //  self.orderList.reverse();
        }

        self.refreshDelay = true;
        self.$forceUpdate();
      });
    },


    filterOutOrder(order) {
      // returns false if the order should be filtered out
      // for valid orders, returns true

      // ignore anything in the order channel exclusion list
      const excludeList = api.appState.orderChannelExclusionList;
      if (excludeList && excludeList.length) {
        for (let e = 0; e < excludeList.length; e++) {
          if (checkFilterCriteria(excludeList[e].channel, order.checkdetails.last_name)
              && checkFilterCriteria(excludeList[e].type, order.checkdetails.name)) {
            return false;
          }

          if (checkFilterCriteria(excludeList[e].emp_num, order.checkdetails.emp_num)
              && checkFilterCriteria(excludeList[e].type, order.checkdetails.name)) {

            return false;
          }           
        }
      }

      return true;
    },

    recallOrder(orderId, resultCallback) {
      // perform recall api call
      console.log('Recall order:' + orderId);

      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getRecallCheck'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;
      
      api.httpGet(apiParameters, function (response) {
        if (typeof resultCallback === "function") {
          resultCallback(response);
        }
      });
    },

    recallLaunch() {
      if (!this.selectedOrder) return;

      var self = this;
      this.recallOrder(this.selectedOrder.order.checkdetails.chk_num, function(response) {
        if (!response || response.data != 99) {
          console.log('Bump api call failed for order:');
          return;
        }

        var index = self.orderList.indexOf(self.selectedOrder.order);

        // perform shrink animation
        self.panelShrink[index] = true;
        self.$forceUpdate();
        
        setTimeout(() => {
          // perform fade animation
          self.panelFade[index] = true;
          self.$forceUpdate();
        }, 400);

        setTimeout(() => {
          self.panelAnimation[index] = false;
          self.recallFinish();
        }, 800);
      });
    },

    recallFinish() {
      if (this.selectedOrder) {
        this.orderList.splice(this.orderList.indexOf(this.selectedOrder.order),1);
      }
      this.selectedOrder = null;
      this.$forceUpdate();

      this.$nextTick(()=> {
        this.panelAnimation = [];
        this.panelShrink = [];
        this.panelFade = [];

        // update UI to show remaining orders deselected
        this.orderList.forEach(order => {
          //this.deselectOrder(order);
          this.panelAnimation.push(false);
          this.panelShrink.push(false);
          this.panelFade.push(false);
        });

        this.$forceUpdate();
      });

      // reset animation after .4 sec
      setTimeout(() => {
        for (var i = 0; i < this.panelAnimation.length; i++) {
          this.panelAnimation[i] = true;
        }

        this.$forceUpdate();
      },400);
    },


    toggleOrderSelect(el, order) {
      console.log('toggle order');

        // find panel in element path
        for (let e=0; e < el.path.length; e++) {
          if (el.path[e].className.indexOf('panel-default') >=0) {
            if (this.selectedOrder && this.selectedOrder.el == el.path[e]) {
              this.setBorder(this.selectedOrder.el, false);
              setTimeout(() => {
                this.deselectOrder(el.path[e]);
              }, 300);              
            } else {
              this.setBorder(el.path[e], true);
              if (this.selectedOrder) {
                this.setBorder(this.selectedOrder.el, false);
              }
              setTimeout(() => {
                this.selectedOrder = {el: el.path[e], order: order};
              }, 300);
            }

            this.selectedOrder = null;
            //this.$$forceUpdate();

            break;
          }
        }
    },

    deselectOrder(el) {
      let del = el;
      if (!del && this.selectedOrder) {
        del = this.selectedOrder.el;
      }

      if (!del) {
        return;
      }

      this.setBorder(del, false);
      this.selectedOrder = null;
    },


    setBorder(panel, selected) {
      if (selected) {
       
        panel.classList.add("selected");
      } else {
       
        panel.classList.remove("selected");
      }
    },

    gotoMain() {
      router.push('/main');
    },

    gotoInfo() {
      router.push('/info');
    },

    reload() {
      location.reload(true);
    },

    init() {
      if (!api.storeSelected) {
        router.push('/login');
      }
      this.getRecallList();

      setTimeout (() => {
        // logout button initially disabled to prevent accidental click
        // re-enable after some time
        this.logoutTimeout = false;
      }, 2000);

      // delay refresh of orders to let api calls catch up
      this.refreshDelay = false;
      setTimeout(() =>{
        this.refreshDelay = true;
        this.$forceUpdate();
      }, 20000);

    }

  },

  mounted: function(){
    console.log('Main page');
    document.body.style.backgroundColor = "#000";
    
    this.init();
  },

  data() {
    return {
        orderList: [],
        selectedOrder: null,
        panelAnimation: [],
        panelShrink: [],
        panelFade: [],
        logoutTimeout: true,
        build: process.env.build,   
        storeNumber: api.storeNumber,
        refreshDelay: false,
        swiperOption: {
          slidesPerView:6,
          slidesPerColumn:3,
          spaceBetween: 5,
          direction: 'horizontal',
          slidesPerColumnFill: 'column',
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar'
          },          
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
            disabledClass: 'invisible',
            hiddenClass: 'invisible'
          }          
        },
        error: ''
    }
  }

}
</script>

<template>
<div>
  <!--
  <div class="pull-right" style="color: white;">{{$t('build_version')}}: {{build}}</div>
  -->
  <div class="row" style="color: white; margin: 0px 0px -5px 0px;">
    <div class="pull-left" 
     style="color: white; 
            font-size: larger; 
            font-weight: bold; 
          "
    >
      <span style="color: #d9534f;">KDS - Order Recall</span>
    </div>
    <div class="pull-right">{{$t('store_number')}}: <b>{{storeNumber}}</b></div>
  </div>

  <div v-show="refreshDelay">
    <div v-if="orderList && orderList.length"  
    class="row" style="position: fixed; height: 88%; width: 100%;"
    >
      <div style="margin: 5px;" >
        <swiper :options="swiperOption"
          class="panel-trans"
          style="height: 95%; width: 100%; padding: 10px 0px;"
        >
          <slide v-for="order, index in orderList" 
          style="height: 25vh;"
          > 
            <div :ref="'order' + order.checkdetails.chk_num"
              @click="toggleOrderSelect($event, order)"
              :class="{'panel': true,
                        'panel-default': true,
                        'box-shadow': true,
                        'panel-trans': panelAnimation[index],
                        'panel-shrinking': panelShrink[index],
                        'panel-fade': panelFade[index]
                      }"
                style="margin: 0px; padding: 0px; height: 24vh;"
              name="panel"
              >
                <orderheader 
                class="panel-heading"
                :recallDisplay="true"
                :checkNum="order.checkdetails.chk_num"
                :revenueType="order.checkdetails.name"
                :firstName="order.checkdetails.first_name"
                :lastName="order.checkdetails.last_name"
                :id="order.checkdetails.id"
                :time="order.checkdetails.displayTime"
                :timeColour="order.checkdetails.timeColour"
                style="padding: 8px 15px; height: 100%;"
                />
                
              </div>
          </slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div v-else class="row" style="height:87%;position: fixed;width:100%; text-align:center;">
      <h3 style="color: white; margin: 20px;">
        {{$t('no_recall_orders')}}
      </h3>
    </div>
  </div>
  <div v-show="!refreshDelay" class="row" style="height:87%;position: fixed;width:100%; text-align:center;">
    <h3 style="color: white; margin: 20px;">
        {{$t('loading')}}...
    </h3>
  </div>

  <div class="row" 
   style="position:fixed;
          bottom:5px;
          margin: 0px 0px 0px -1px;
          width:100%;
          z-index:20">
      <table style="width:100%; ">
        <tr>
              <td style="padding:0px 20px 0px 0px">
                <button 
                  @click="gotoMain()"
                  class="btn btn-lg btn-block btn-success" 
                  style="height: 60px; "
                  ><i 
                  class="fas fa-arrow-left pull-left"
                  style="margin: 2px 5px 0px 0px;"
                  ></i>{{$t('back')}}
                </button>                
              </td>
              <td style="padding:0px 10px;">
                <div v-if="orderList && orderList.length" 
                      class="btn btn-block btn-lg btn-default button-prev btn-modified pull-right" 
                      style="width: 120px; background-color: #00ffff;"
                      slot="button-prev"
                      
                      @click="deselectOrder()"
                      ><i class="fas fa-chevron-left"></i> {{$t('prev')}}
                </div>
             </td> 
             <td>
                <button 
                    @click="recallLaunch()"
                    class="btn btn-block btn-lg btn-danger"
                    style="height: 60px; width: 100%;"
                    :disabled="!selectedOrder"
                    ><i 
                    class="fas fa-undo pull-left"
                    style="margin: 2px 0px 0px 0px;"
                    ></i>{{$t('recall_order')}}
                </button>
             </td>  
             <td style="padding:0px 10px;">
                <div v-if="orderList && orderList.length" 
                    class="btn btn-block btn-lg  btn-default button-next btn-modified" 
                    style="width: 120px; background-color: #00ffff;"
                    slot="button-next"
                      @click="deselectOrder()"
                    >{{$t('next')}} <i class="fas fa-chevron-right"></i>
                </div>
             </td>  
             <td style="padding: 0px 20px 0px 0px;">
              <button 
              @click="gotoInfo()"
              class="btn btn-lg pull-right btn-default"
              style="height: 40px; width: 40px; padding: 9px; font-weight: bold; border-radius: 50%; background-color: #000; border: none; color: #fff;"
              :disabled="logoutTimeout"
              ><i class="fas fa-info-circle pull-left"
                style="margin: 2px 5px 0px 0px;"></i>
              </button>
             </td>               
         </tr> 
      </table> 
  </div>
</div>
</template>

<style scoped>
.selected {
  border:solid 3px #ff0000;
}
.selected .panel-heading {
  background: #fce4ec;
}
</style>


// WEBPACK FOOTER //
// RecallDisplay.vue?30b38b7a